export const paymentsStatusToPayExcessFee = [
  20900, 21201, 31201, 31202, 31203, 41201, 51202, 51202, 51203, 51204, 51205,
];
